import Swiper, { Navigation } from "swiper";

const BasicSlider = function () {

    const sections = document.querySelectorAll( '.basic-slider' );

    Swiper.use([Navigation]);

    for (const section of sections) {
        const swiperEl = section.querySelector( '.swiper' );
        const prevEl = section.querySelector( '.swiper-button-prev' );
        const nextEl = section.querySelector( '.swiper-button-next' );
        console.log(prevEl, nextEl);
        const swiper = new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl,
                prevEl
            },
        })
    }

}
  
export default BasicSlider